import clsx from 'clsx';
import { Icon, Typography } from '@/components/common';
import { AvatarName } from '@/components/dashboard';
import {
	LawyerInboxListItem,
	LawyerCaseItem,
	LawyerClientsItem,
	Subjects,
	TableData,
} from '@/interfaces/inbox';
import { Options } from '@/components/ui/combobox';
import Icons from '@/const/icons';
import { InputRangeDate } from '@/components/form';
import { ButtonContentFilter } from '@/components/screens/lawyerapp/client-directory/filters';
import { DateI } from '@/components/screens/lawyerapp/inbox/InboxList';

export class InboxAdapter {
	static tableDataAdapter(listCases: LawyerInboxListItem[]): TableData[] {
		return listCases.map((item) => ({
			...item,
			isRead: item.is_read,
			name: (
				<AvatarName
					firstname={item.firstname}
					lastname={item.lastname}
					photoUrl={item.profile_picture}
					isBold={!item.is_read}
					size="small"
					className="flex-col !items-start"
					subtitle={
						<div className="flex items-center gap-x-1">
							<Icon
								width={16}
								height={16}
								src={
									item.is_from_client
										? Icons.arrowDownRight
										: Icons.arrowUpRight
								}
								className="text-opacity-black size-4"
							/>
							<Typography type="regular-12" className="text-opacity-black">
								{item.is_from_client ? 'Received' : 'Sent'}
							</Typography>
						</div>
					}
				/>
			),
			subject: (
				<Typography
					type="regular-14"
					className={clsx('line-clamp-1 ', {
						'font-semibold': !item.is_read,
					})}
					text={item.subject}
				/>
			),
			case: (
				<Typography
					type="regular-14"
					className={clsx('opacity-60 line-clamp-1', {
						'font-semibold': !item.is_read,
					})}
					text={
						item.case_name === 'No case assigned' || !item.case_name
							? '-'
							: item.case_name
					}
				/>
			),
			isActive: !item.is_read,
		}));
	}

	static subjectFilterAdapter(subjects: Subjects[]): Options[] {
		return subjects.map((subject) => ({
			label: subject.title,
			value: subject.id,
			icon: <Icon src={Icons.sms} className="!w-4 !h-4 text-primary" />,
		}));
	}

	static clientFilterAdapter(clients: LawyerClientsItem[]): Options[] {
		return clients.map((client) => ({
			label: (
				<AvatarName
					firstname={client.firstname}
					lastname={client.lastname}
					photoUrl={client.profile_picture}
					size="small"
				/>
			),
			value: client.id,
		}));
	}

	static caseFilterAdapter(listCases: LawyerCaseItem[]): Options[] {
		return listCases
			.filter((item) => item?.case)
			.map((item) => ({
				label: item.case.caseName,
				value: item.case.caseId,
				icon: <Icon src={Icons.briefcase} className="!w-4 !h-4 text-primary" />,
			}));
	}

	static dateFilterAdapter(
		startDate: string,
		endDate: string,
		setDate: (value: DateI | undefined) => void
	): JSX.Element {
		return (
			<InputRangeDate
				name="date"
				register={'' as any}
				className="w-[404px]"
				classNameInput="!placeholder-[#0D061633]"
				setValueInput={(_: string, value: DateI) => setDate(value)}
				buttonCustom
				buttonContent={
					<ButtonContentFilter active={!!startDate && !!endDate} />
				}
				dateFrom={startDate}
				dateTo={endDate}
				isFormatted={false}
				restrictToPast
			/>
		);
	}
}
